export const themes = {
    dark: {
      "--backround-color-01": "#0C0C0C",
      "--background-color-02": "#191919",
      "--background-color-03": "#0C0C0C",
      "--component-color-01": "#1E1E1E",
      "--component-color-02": "#3C3C3C",
      "--component-color-03": "#3C3C3C",
      "--component-color-selected": "#F0F0F0",
      "--border-color-01": "#3C3C3C",
      "--border-color-02": "#1E1E1E",
      "--text-color-01": "#FFFFFF",
      "--color-warning": "#FF0016",
      "--text-color-02": "#0C0C0C",
      "--text-color-inactive": "#808080"
    },
    light: {
      "--backround-color-01": "#F8F8F8",      
      "--background-color-02": "#E5E5E5",
      "--background-color-03": "#F8F8F8",     
      "--component-color-01": "#E0E0E0",      
      "--component-color-02": "#C8C8C8",      
      "--component-color-03": "#C8C8C8",       
      "--component-color-selected": "#2A2A2A", 
      "--border-color-01": "#BEBEBE",         
      "--border-color-02": "#A8A8A8",          
      "--text-color-01": "#050505",           
      "--color-warning": "#FF0016",          
      "--text-color-02": "#FFFFFF",           
      "--text-color-inactive": "#7A7A7A"      
  },
    
  }
  